import React from 'react';
import Typography from '@material-ui/core/Typography';

import { useForm } from 'react-hook-form';
import { useModalContext } from '@dataswift/shared';
import { DSButton } from '../../components/Button/Button';
import { formValidators, getErrorMessage } from '../../helpers/formErrorMessages';
import { submitSupportRequest } from '../../services/DevPortalService';
import { ErrorModal, SuccessModal } from '../../components/Modals/SupportEmail/SupportModals';
import Paper from '../../styles/templates/Paper';
import TextField from '../../styles/templates/DSTextField';
import { ContentRow } from '../../styles/templates/PageTemplates';

type FormType = {
  firstName: string;
  lastName: string;
  email: string;
  description: string;
};

const SupportForm: React.FC = () => {
  const { openModal } = useModalContext();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<FormType>();

  const doSubmit = async (data: FormType) => {
    try {
      await submitSupportRequest(data);
      reset();
      openModal({ open: true, component: SuccessModal });
    } catch (e) {
      openModal({ open: true, component: ErrorModal });
    }
  };

  return (
    <form onSubmit={handleSubmit(doSubmit)}>
      <Paper>
        <Typography variant="subtitle1">Support Form</Typography>

        <ContentRow>
          <TextField
            inputProps={register('firstName', { required: true })}
            id="firstName"
            label="First Name"
            variant="outlined"
            className="formInput"
            autoComplete="off"
            error={!!errors.firstName}
            helperText={getErrorMessage(errors.firstName)}
            focused={false}
          />

          <TextField
            inputProps={register('lastName', { required: true })}
            id="lastName"
            label="Surname"
            variant="outlined"
            className="formInput"
            autoComplete="off"
            error={!!errors.lastName}
            helperText={getErrorMessage(errors.lastName)}
            focused={false}
          />
        </ContentRow>

        <ContentRow>
          <TextField
            inputProps={register('email', { required: true, validate: formValidators.email })}
            id="email"
            label="Email Address"
            variant="outlined"
            className="formInput"
            autoComplete="off"
            error={!!errors.email}
            helperText={getErrorMessage(errors.email)}
            focused={false}
          />
        </ContentRow>

        <ContentRow>
          <TextField
            inputProps={register('description', { required: true })}
            id="description"
            label="Tell us what you need support with..."
            variant="outlined"
            className="formInput wide multiline"
            autoComplete="off"
            multiline
            rows={3}
            error={!!errors.description}
            helperText={getErrorMessage(errors.description)}
            focused={false}
          />
        </ContentRow>

        <div className="ds-support-buttons">
          <DSButton type="submit">Submit</DSButton>
        </div>
      </Paper>
    </form>
  );
};

export default SupportForm;
